<template>
    <div class="subscribe-wrapper">
        <a-modal
            class="subscribe"
            :visible="visible"
            :title="$t('program.subscribe_record'/*订阅记录*/ )"
            :width="1100"
            :maskClosable="false"
            :confirm-loading="loading"
            @cancel="handleCancel"
            :footer="null">
            <!--    搜索条件    -->
            <div class="table-page-search-wrapper" ref="myHeader">
                <a-form layout="inline" class="hidden">
                    <a-row :gutter="[10, 10]">
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-select v-model="searchParams.date" :placeholder="$t('program.batch_live_label_date'/*日期*/ )">
                                    <a-select-option v-for="(item, index) in dateList" :key="index" :value="item.id">{{item.meeting_date}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-select v-model="searchParams.hall" :placeholder="$t('program.meeting_hall'/*会场*/ )">
                                <a-select-option v-for="(item, index) in hallList" :key="index" :value="item.id">{{item.meeting_hall}}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-select v-model="searchParams.class" :placeholder="$t('program.forum'/*分论坛*/ )">
                                    <a-select-option v-for="(item, index) in xuezuList" :key="index" :value="item.id">{{item.class_cnname}}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.title" :placeholder="$t('program.session_title'/*Session标题*/ )" />
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-button type="primary" @click="handleSearch">{{$t('web.search'/*搜索*/ )}}</a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table ref="table" size="default" :rowKey="record => record.order_id" :columns="columns" :dataSource="dataList" :pagination="false" class="mt20">
                
            </a-table>
            <div class="t-r mt30">
                <a-pagination
                    :show-total="total => $t('web.pagination_total', { value: total } /* 共{value}条 */)"
                    show-size-changer
                    v-model="pagination.page"
                    :page-size="pagination.limit"
                    :total="paginationTotal"
                    @change="handlePaginationChangeEvent"
                    @showSizeChange="handlePaginationChangeEvent"
                />
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'subscribeModal',
    props: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            type: 1,  // 1 Session订阅记录
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'center',
                    fixed: 'left',
                    width: 50
                },
                {
                    title: this.$t('program.batch_live_label_date'/*日期*/),
                    dataIndex: 'meeting_date',
                    align: 'center',
                    width: 120
                },
                {
                    title: this.$t('program.meeting_hall'/*会场*/),
                    dataIndex: 'meeting_hall',
                    align: 'center',
                    width: 130
                },
                {
                    title: this.$t('program.forum'/*分论坛*/),
                    dataIndex: 'class_cnname',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.session_title'/*Session标题*/),
                    dataIndex: 'abstract_title',
                    align: 'center',
                    width: 100
                },

                {
                    title: this.$t('program.user_name'/*用户姓名*/),
                    dataIndex: 'real_name',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.subscribe_time'/*订阅时间*/),
                    dataIndex: 'update_time',
                    align: 'center',
                    width: 100
                }
            ],
            searchParams: {
            },
             // 分页
            pagination: {
                page: 1,
                limit: 10
            },
            dataList: [],
            paginationTotal: 0,
            dateList: [],
            hallList: [],
            xuezuList: []
        };
    },
    created () {
        this.getProgramHallList()
        this.getProgramDateList()
        this.getProgramXuezuList()
    },
    methods: {
        /**
         * 打开日程订阅记录弹窗
         * @param type 类型 1 Session订阅记录 2日程订阅记录
        */
        showFun(type) {
            this.type = type
            this.visible = true
            this.getDataList()
        },
        getDataList () {
            let data = {
                ...this.searchParams,
                ...this.pagination
            }
            this.loading = true
            this.$request.get({ url: this.type == 1 ? 'getSessionSubscrilbeList' : 'getProgramSubscrilbeList', data }).then((res) => {
                const { count, list } = res.data
                this.dataList = list
                this.paginationTotal = Number(count)
            }).finally(() => {
                this.loading = false
            })
        },
        handleCancel() {
            this.visible = false;
        },
        // 会场列表
        getProgramHallList () {
            this.$request.get({ url: 'getProgramHallList' }).then((res) => {
                this.hallList = res.data
            })
        },
        // 日期列表
        getProgramDateList () {
            this.$request.get({ url: 'getProgramDateList' }).then((res) => {
                this.dateList = res.data
            })
        },
        // 分论坛列表
        getProgramXuezuList () {
            this.$request.get({ url: 'getProgramXuezuList' }).then((res) => {
                this.xuezuList = res.data
            })
        },
        handleSearch () {
            this.getDataList()
        },
        // 切换分页
        handlePaginationChangeEvent(page, limit) {
            this.pagination = {
                page,
                limit
            };
            this.getDataList();
        }
    },
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item {
    margin-bottom: 0px;
}
</style>